// extracted by mini-css-extract-plugin
module.exports =  {"shadow":"_0bc5e8de02--shadow--gHUci"};